import React from 'react';
import { sanitizeD365RichTextEditor } from '../../../utils/htmlTextConverter';
import EmailPreview from './EmailPreview';

type Props = {
  note: string;
};

const RecommendServiceMailCustomer: React.FC<Props> = ({ note }) => {
  return (
    <EmailPreview>
      <div
        dangerouslySetInnerHTML={{
          __html: sanitizeD365RichTextEditor(note),
        }}
      ></div>
    </EmailPreview>
  );
};

export default RecommendServiceMailCustomer;
